export default __webpack_public_path__ + "static/media/property_348.5bfb1744.png";